import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { compose, withHandlers, withProps, withState } from 'recompose'

// Components
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { StyledButton } from '../../theme/Global'

const DatePickerRenderer = ({ apply, endDate, handleChange, startDate }) => (
  <React.Fragment>
    <Grid container spacing={24}>
      <Grid item xs={6}>
        <TextField
          id="startDate"
          label="Start Date"
          type="date"
          onChange={handleChange}
          value={startDate}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id="endDate"
          label="End Date"
          type="date"
          onChange={handleChange}
          value={endDate}
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
    </Grid>
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <StyledButton onClick={apply}>
          Apply
        </StyledButton>
      </Grid>
    </Grid>
  </React.Fragment>
)

DatePickerRenderer.propTypes = {
  apply: PropTypes.func.isRequired,
  endDate: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired
}

export const dateProps = (props) => ({
  apply: () => {
    props.onSelect(props.startDate, props.endDate)
  }
})

export const dateHandlers = {
  handleChange: (props) => (event) => {
    const name = event.target.id
    if (name === 'startDate') {
      props.setStartDate(event.target.value)
    } else {
      props.setEndDate(event.target.value)
    }
  }
}
const today = new Date()
const DatePickerComponent = compose(
  withState('startDate', 'setStartDate', moment(today).format('YYYY-MM-DD')),
  withState('endDate', 'setEndDate', moment(today).format('YYYY-MM-DD')),
  withProps(dateProps),
  withHandlers(dateHandlers)
)(DatePickerRenderer)

export default DatePickerComponent
